<div *ngFor="let m of messages$ | async" [class]="m.severity" class="container"  [@anim]="m">
   <div style="position: relative;"> <div class="close" (click)="remove(m)"><i class="fal fa-times-circle"></i></div></div>
    <div class="message">{{m.message}}</div>
    <div class="sub-message">{{m.subMessage}}</div>    
</div>
